var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(_vm.chartVisible)?_c('v-chart',_vm._b({ref:"chart",on:{"click":_vm.doClick}},'v-chart',{
            theme: _vm.theme,
            autoresize: _vm.autoresize,
            loading: _vm.loading,
            'init-options': { renderer: 'svg' },
            option: _vm.mergedOptions,
        },false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }